import React, { Component } from "react";
import PropTypes from "prop-types";
import "./PixelTemperature.css";

export default class PixelTemperature extends Component {

    tempValue = (pixelTemp, isCelsius, isCelsiusImg)  => {

        if (isCelsius && isCelsiusImg ) return pixelTemp + " \u00B0C"
    
       
        else return pixelTemp + " \u00B0F";

    }

  render() { 
      const { pixelTemp, isCelsius, isCelsiusImg} = this.props;
      return (
          <div className="pixelTemp">
              {this.tempValue(pixelTemp, isCelsius, isCelsiusImg)}
          </div> 
      
       );
  }
};



PixelTemperature.propTypes = {
    pixelTemp: PropTypes.number.isRequired,
};
